if (window.BaseModal && !customElements.get('contact-modal')) {
  customElements.define(
    'contact-modal',
    class ContactModal extends window.BaseModal {
      constructor() {
        super()
        this.image = this.querySelector('[data-modal-image]')
      }

      onOpen() {
        this.revealImage()
      }

      revealImage() {
        if (!window.gsap || !this.image) return
        window.gsap.fromTo(this.image, { scale: 1.08 }, { scale: 1, duration: 1.3, ease: 'power3.out' })
      }
    },
  )
}

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('contact-modal')
  if (!modal) return

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-contact-modal-open]')
    if (!opener) return
    event.preventDefault()
    modal.open(opener)
  })

  modal.querySelector('form')?.addEventListener('submit', () => sessionStorage.setItem('contact-form', 'contact'))

  if (!modal.querySelector('[data-contact-modal-flag]')) return
  if (sessionStorage.getItem('contact-form') === 'cancellation') return

  modal.open()
})
